import { useAuthState } from '@creditornot/wolt-auth/react';

import useFeatureFlags from 'common/hooks/useFeatureFlags';
import { hasPermissions, usePermissions } from 'common/wolt-permissions';

export const useIsGoogleSheetsEnabled = () => {
  const { user } = useAuthState();
  const permissions = usePermissions();
  const userId = user?.id;

  const hasUserPermission = hasPermissions([{ resource: 'restaurant', operations: ['r'] }], permissions);

  const { data: featureFlags } = useFeatureFlags(['enable_google_sheets_feature'], {
    user_id: userId || '',
    user_country: user?.country ?? '',
  });

  return hasUserPermission && featureFlags?.enable_google_sheets_feature === 'on';
};
